import { setExitButtonWinningState, resetExitButton } from '../ui/ExitButton.js';

// confetti array:
const CONFETTI_ASSETS = [
    'confettiBlue',
    'confettiBlue2',
    'confettiGreen',
    'confettiPink',
    'confettiYellow'
];

export function getRewardForScore(scene, score) {

    let earnedReward = 0;

    scene.pointsRewardThreshold.forEach(threshold => {
        if (score >= threshold.requiredPoints) {
            earnedReward = threshold.reward;
        }
    });

    return earnedReward;
}


export function getRandomCatchphrase(scene, reward) {

    const sourceArray = reward > 0 ? scene.winningCatchphrase : scene.losingCatchphrase;

    const index = Phaser.Math.Between(0, sourceArray.length - 1);

    return sourceArray[index];
}


export function showGameOverOverlay(scene) {

    const { width, height } = scene.scale;

    scene.game.renderer.snapshot((image) => {

        // ----------------------------
        // Blurred background image
        // ----------------------------

        const blurredBg = scene.add.image(width / 2, height / 2, image);

        if (scene.game.renderer.type === Phaser.WEBGL) {
            blurredBg.postFX.addBlur(6);
        }

        blurredBg.setDepth(100);

        // ----------------------------
        // Final score
        // ----------------------------

        const finalScore = scene.score;

        const reward = getRewardForScore(scene, finalScore);

        // ----------------------------
        // overlay
        // ----------------------------

        const overlayColor = reward > 0 ? 0xEE5298 : 0xFFC72F;

        const overlay =
            scene.add.rectangle(
                width / 2,
                height / 2,
                width,
                height,
                overlayColor,
                //0.90      // opacity
                1
            );

        overlay.setDepth(101);


        let scoreY = height / 2 - 145;

        if(reward > 0) {
            scoreY = height / 2 - 205;
        }
        
        // =========================================================
        // SCORE BADGE
        // =========================================================

        /*
        const scoreY =
            height / 2 - 145;
        */

        let scoreBadgeWidth = 100;
        const scoreBadgeHeight = 28;
        
        if(reward) {
            scoreBadgeWidth = 200;
        }
        

        const scoreBadge = scene.add.graphics();

        /*
        const scoreBadgeColor =
            reward > 0
                ? 0xFFFFFF
                : 0xF48DBC;
        */
       const scoreBadgeColor = 0xF48DBC;

        scoreBadge.fillStyle(scoreBadgeColor, 1);

        scoreBadge.fillRoundedRect(
            width / 2 - scoreBadgeWidth / 2,

            scoreY - scoreBadgeHeight / 2,

            scoreBadgeWidth,
            scoreBadgeHeight,

            scoreBadgeHeight / 2
        );

        scoreBadge.setDepth(102);

        // ----------------------------
        // switch the X button for a white one
        // ----------------------------

        if(reward) {
            setExitButtonWinningState(scene);
        }

        // ----------------------------
        // Score donut icon
        // ----------------------------

        let scoreIcon;

        if(reward) {
            scoreIcon =
                scene.add.image(
                    width / 2 - 90,
                    scoreY,
                    'winRewardDonut'
                );
        } else {
            scoreIcon =
                scene.add.image(
                    width / 2 - 40,
                    scoreY,
                    'scoreDonut'
                );
        }

        scoreIcon.setOrigin(0.5).setDepth(103);

        scoreIcon.setDisplaySize(42, 42);

        // ----------------------------
        // Score number
        // ----------------------------

        const scoreTextColor = '#FFFFFF';
        //const scoreTextColor = '#EE5298';

        /*
        const scoreTextColor =
            reward > 0
                ? '#EE5298'
                : '#FFFFFF';
        */

        //console.log("+" + String(reward) + scene.rewardedPointsName?.translations?.en);     
        if(reward) {
            let stringvalue = "+" + String(reward) + " " + (scene.rewardedPointsName?.translations?.en || "points");

            const scoreText =
                scene.add.text(
                    width / 2 + 10,
                    scoreY,
                    stringvalue,
                    {
                        fontFamily: 'paytoneone',
                        fontSize: '20px',
                        color: scoreTextColor
                    }
                )

            scoreText.setOrigin(0.5).setDepth(103);
        } else {
            const scoreText =
                scene.add.text(
                    width / 2 + 10,
                    scoreY,
                    String(finalScore),
                    {
                        fontFamily: 'paytoneone',
                        fontSize: '20px',
                        color: scoreTextColor
                    }
                )

            scoreText.setOrigin(0.5).setDepth(103);
        }

        // =========================================================
        // TITLE
        // =========================================================

        const titleY = height / 2 - 60;

        let timeUpText;

        if (reward > 0) {

            timeUpText =
                scene.add.text(
                    width / 2,
                    titleY - 60,
                    //'CONGRATULATION!',
                    'Félicitation, tu as gagné!',
                    {
                        fontFamily: 'paytoneone',
                        fontSize: '34px',
                        color: '#FFFFFF',
                        align: 'center',
                        wordWrap: {
                            width: width - 110,
                            useAdvancedWrap: true
                        }
                    }
                )
                .setOrigin(0.5)
                .setDepth(103);

                /*
                scene.add.text(
                    0,
                    currentY,
                    formattedRegular,
                    {
                        fontFamily: 'Poppins',
                        fontSize: '20px',
                        color: hexColor,
                        align: 'center',
                        wordWrap: {
                            width: width - 100,
                            useAdvancedWrap: true
                        }
                    }
                )
                */

            launchConfetti(scene);

            // Safe to trigger the reward here
            // to the user's account.
            scene.givePoints?.();

        } else {

            timeUpText =
                scene.add.text(
                    width / 2,
                    titleY - 10,
                    'Temps écoulé!',
                    {
                        fontFamily: 'paytoneone',
                        fontSize: '30px',
                        color: '#FFFFFF',
                        align: 'center'
                    }
                )
                .setOrigin(0.5)
                .setDepth(103);
        }


        // =========================================================
        // CATCHPHRASE
        // =========================================================

        const catchphrase = getRandomCatchphrase(scene, reward);

        const hexColor =
            '#' +
            (
                catchphrase?.color ||
                0xffffff
            )
                .toString(16)
                .padStart(6, '0');


        const messageContainer =
            scene.add.container(
                width / 2,
                height / 2 - 10
            );

        messageContainer.setDepth(103);


        let currentY = 0;

        const elements = [];


        // ----------------------------
        // Helper to split long text
        // ----------------------------

        const formatText = (text) => {

            if (!text) {
                return '';
            }

            return text;
        };


        // =========================================================
        // BOLD TEXT
        // =========================================================

        const formattedBold = formatText(catchphrase?.boldText);

        if (formattedBold) {

            const boldTextObj =
                scene.add.text(
                    0,
                    currentY,
                    formattedBold,
                    {
                        fontFamily: 'paytoneone',
                        fontSize: '24px',
                        color: hexColor,
                        align: 'center'
                    }
                )
                .setOrigin(0.5);


            elements.push(boldTextObj);


            currentY += boldTextObj.height + 10;
        }


        // =========================================================
        // REGULAR TEXT
        // =========================================================

        const formattedRegular = formatText(catchphrase?.regularText);

        if (formattedRegular) {

            const regularTextObj =
                scene.add.text(
                    0,
                    currentY,
                    formattedRegular,
                    {
                        fontFamily: 'Poppins',
                        fontSize: '20px',
                        color: hexColor,
                        align: 'center',
                        wordWrap: {
                            width: width - 100,
                            useAdvancedWrap: true
                        }
                    }
                )
                .setOrigin(0.5);

            elements.push(regularTextObj);

            currentY += regularTextObj.height + 15;
        }


        // Add text elements
        messageContainer.add(elements);


        // =========================================================
        // RECOMMENCER BUTTON
        // =========================================================

        const buttonWidth = 180;
        const buttonHeight = 46;

        const restartY = height / 2 + 105;

        // ----------------------------
        // Pink outer capsule
        // ----------------------------

        const restartButton = scene.add.graphics();

        const restartOuterColor = reward > 0 ? 0xFFFFFF : 0xF04F9D;

        restartButton.fillStyle(restartOuterColor, 1);

        restartButton.fillRoundedRect(
            width / 2 - buttonWidth / 2,
            restartY - buttonHeight / 2,
            buttonWidth,
            buttonHeight,
            buttonHeight / 2
        );

        restartButton.setDepth(102);


        // ----------------------------
        // Yellow inner capsule
        // ----------------------------

        const restartButtonInner = scene.add.graphics();

        const innerWidth = buttonWidth - 8;

        const innerHeight = buttonHeight - 8;

        /*
        restartButtonInner.fillStyle(
            0xFFC72F,
            1
        );
        */
       const restartInnerColor = reward > 0 ? 0xEE5298 : 0xFFC72F;

        restartButtonInner.fillStyle(restartInnerColor, 1);

        restartButtonInner.fillRoundedRect(
            width / 2 - innerWidth / 2,
            restartY - innerHeight / 2,
            innerWidth,
            innerHeight,
            innerHeight / 2
        );

        restartButtonInner.setDepth(103);


        // ----------------------------
        // Button text
        // ----------------------------

        const restartTextColor = reward > 0 ? '#FFFFFF' : '#F04F9D';

        const restartText =
            scene.add.text(
                width / 2,
                restartY,
                'Recommencer',
                {
                    fontFamily: 'paytoneone',
                    fontSize: '20px',
                    color: restartTextColor,
                    align: 'center'
                }
            )
            .setOrigin(0.5)
            .setDepth(104);


        // ----------------------------
        // Button interaction
        // ----------------------------

        restartButton.setInteractive(
            new Phaser.Geom.Rectangle(
                width / 2 - buttonWidth / 2,
                restartY - buttonHeight / 2,
                buttonWidth,
                buttonHeight
            ),
            Phaser.Geom.Rectangle.Contains
        );

        restartButton.on(
            'pointerdown',
            () => {
                resetExitButton(scene);
                scene.scene.restart();
            }
        );


        // Make the text interactive too

        restartText.setInteractive({useHandCursor: true});

        restartText.on(
            'pointerdown',
            () => {
                resetExitButton(scene);
                scene.scene.restart();
            }
        );

        /*
        // Make the text interactive too
        restartText.setInteractive({useHandCursor: true});

        restartText.on(
            'pointerdown',
            () => {
                scene.scene.restart();
            }
        );
        */


        // Keep the timer state behavior
        scene.remainingTime = scene.startTime;

    });
}

function launchConfetti(scene) {

    const { width, height } = scene.scale;

    const confettiCount = 45;

    const startX = width / 2;
    const startY = height + 30;

    const confettiPieces = [];


    for (let i = 0; i < confettiCount; i++) {

        const textureKey = Phaser.Utils.Array.GetRandom(CONFETTI_ASSETS);

        if (!scene.textures.exists(textureKey)) {
            continue;
        }

        const x = startX + Phaser.Math.Between(-45, 45);

        const y = startY + Phaser.Math.Between(-10, 20);


        const confetti = scene.add.image(x, y, textureKey);

        confetti.setDepth(110);


        const size = Phaser.Math.Between(12, 22);

        confetti.setDisplaySize(size, size);

        confetti.rotation = Phaser.Math.FloatBetween(0, Math.PI * 2);

        // --------------------------------------------
        // Initial launch velocity
        // --------------------------------------------

        confetti.confettiVelocityX = Phaser.Math.Between(-550, 550);

        confetti.confettiVelocityY = Phaser.Math.Between(-950, -700);

        // --------------------------------------------
        // Gravity
        // --------------------------------------------

        confetti.confettiGravity = Phaser.Math.Between(700, 950);

        // --------------------------------------------
        // Rotation
        // --------------------------------------------

        confetti.confettiRotation = Phaser.Math.FloatBetween(-8, 8);

        confettiPieces.push(confetti);
    }


    // --------------------------------------------------
    // Animate all confetti
    // --------------------------------------------------

    const updateConfetti = (time, delta) => {

        const dt = delta / 1000;

        for (let i = confettiPieces.length - 1; i >= 0; i--) {

            const confetti =confettiPieces[i];

            if (!confetti || !confetti.active) {
                confettiPieces.splice(i, 1);
                continue;
            }


            // --------------------------------------------
            // Gravity
            // --------------------------------------------

            confetti.confettiVelocityY += confetti.confettiGravity * dt;

            // --------------------------------------------
            // Movement
            // --------------------------------------------

            confetti.x += confetti.confettiVelocityX * dt;

            confetti.y += confetti.confettiVelocityY * dt;

            // --------------------------------------------
            // Rotation
            // --------------------------------------------

            confetti.rotation += confetti.confettiRotation * dt;

            // --------------------------------------------
            // Remove once off-screen
            // --------------------------------------------

            const margin = 80;


            if (confetti.y > height + margin || confetti.x < -margin || confetti.x > width + margin) {

                confetti.destroy();
                confettiPieces.splice(i, 1);
            }
        }


        // --------------------------------------------
        // Stop update loop when finished
        // --------------------------------------------

        if (confettiPieces.length === 0) {
            scene.events.off('update', updateConfetti);
        }
    };


    scene.events.on('update', updateConfetti);
}